
import { Component, OnInit, ElementRef } from '@angular/core';
import {Location} from '@angular/common';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login/login.service';
import { EmpresasService } from '../../services/empresas/empresas.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

     minimo:boolean=true;
    private listTitles: any[];
    location: Location;
    user:any;
      mobile_menu_visible: any = 0;
    private toggleButton: any;
    private sidebarVisible: boolean;
    abrirCambiarContrasena : boolean = false;
    abrirCambiarFoto : boolean = false;
    loading: boolean;
    dataImage:any;

    constructor(location: Location,  private element: ElementRef, private router: Router ,
                 private loginService:LoginService,
                    private empresasService:EmpresasService ) {
    this.user = JSON.parse(sessionStorage.getItem("UserActive"));
    console.log("user",this.user);
   
    this.validarToken();

      this.location = location;
          this.sidebarVisible = false;
    }

    ngOnInit(){
      if (this.loginService.uploadImage) {
        this.dataImage = JSON.parse(sessionStorage.getItem("uploadFoto"));
      }else{
        this.dataImage = JSON.parse(sessionStorage.getItem("Foto"));
      }
      const navbar: HTMLElement = this.element.nativeElement;
      this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
      this.router.events.subscribe((event) => {
        this.sidebarClose();
         var $layer: any = document.getElementsByClassName('close-layer')[0];
         if ($layer) {
           $layer.remove();
           this.mobile_menu_visible = 0;
         }
     });
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function(){
            toggleButton.classList.add('toggled');
        }, 500);

        body.classList.add('nav-open');

        this.sidebarVisible = true;
    }
    sidebarClose() {
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        body.classList.remove('nav-open');
    }
    sidebarToggle() {

        var $toggle = document.getElementsByClassName('navbar-toggler')[0];

        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
        const body = document.getElementsByTagName('body')[0];

        if (this.mobile_menu_visible == 1) {
            body.classList.remove('nav-open');
            if ($layer) {
                $layer.remove();
            }
            setTimeout(function() {
                $toggle.classList.remove('toggled');
            }, 400);

            this.mobile_menu_visible = 0;
        } else {
            setTimeout(function() {
                $toggle.classList.add('toggled');
            }, 430);

            var $layer = document.createElement('div');
            $layer.setAttribute('class', 'close-layer');


            if (body.querySelectorAll('.main-panel')) {
                document.getElementsByClassName('main-panel')[0].appendChild($layer);
            }else if (body.classList.contains('off-canvas-sidebar')) {
                document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
            }

            setTimeout(function() {
                $layer.classList.add('visible');
            }, 100);

            $layer.onclick = function() { //asign a function
              body.classList.remove('nav-open');
              this.mobile_menu_visible = 0;
              $layer.classList.remove('visible');
              setTimeout(function() {
                  $layer.remove();
                  $toggle.classList.remove('toggled');
              }, 400);
            }.bind(this);

            body.classList.add('nav-open');
            this.mobile_menu_visible = 1;

        }
    }

    getTitle(){
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }
      this.listTitles.forEach((item,index)=>{
        if(this.listTitles[index].path === titlee){
          return this.listTitles[index].title;
      } 
      })
     
      return 'Dashboard';
    }

    Toogle(){
        
        this.minimo = !this.minimo;
        localStorage.setItem('minimo', this.minimo.toString())
    }

    validar(){
      return localStorage.getItem('minimo');
   
      }

      CerrarSession(){
        sessionStorage.clear();
         this.loginService.TOKEN = "";
        this.router.navigate(['/login']);
      }

      validarToken(){

        try {
            
            let TOKEN2 =  sessionStorage.getItem('Kn48Nki8is9dhan54648asm78f6s3JDF56L4Ndf2SDdas55');
             let array = TOKEN2.split("ñ",18);

            for (let index = 0, i = 16; index < array.length; index++ , i--) {
                if (array[index] != array[i]){
                    this.router.navigate(['/login']);
                }
            }


        } catch (error) {
            this.router.navigate(['/login']);
        } 
      }

      CambiarContrasena(){
        this.abrirCambiarContrasena = true;
      }

      CerrarPopUpCambiarContrasena(clik:boolean){
    
        this.abrirCambiarContrasena = false;
      }

      CambiarFoto(){
        this.abrirCambiarFoto = true;
      }
      CerrarPopUpCambiarFoto(clik:boolean){
    
        this.abrirCambiarFoto = false;
      }
      Refresh(){
        this.ngOnInit();
      }


      
}
